import MobPopupI from '../types.ts';

const disabledDocument: MobPopupI['disabledDocument'] = function (isDisabled) {
    const body = document.querySelector('body');

    body!.classList[isDisabled ? 'add' : 'remove']('_isDrag');
};

export default disabledDocument;
